import { createContext, useContext, useState, useEffect } from 'react';

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [state, setState] = useState({
    user: null,
    theme: 'light',
    language: 'zh-CN',
    isInitialized: false,
    isLoading: true,
    modalOpen: false,
    modalType: null,
    modalData: null,
    navigationState: {
      activeItem: 'dashboard',
      menuGroups: null
    },
    appConfig: {
      appName: 'Liu Er Site',
      version: '1.0.0',
      description: '基于 MVVM 架构的现代化 React 应用'
    }
  });

  // 初始化应用
  useEffect(() => {
    // 模拟应用初始化过程
    const initializeApp = async () => {
      try {
        // 延迟1秒，模拟加载过程
        await new Promise(resolve => setTimeout(resolve, 1000));
        
        setState(prevState => ({
          ...prevState,
          isInitialized: true,
          isLoading: false
        }));
      } catch (error) {
        console.error('应用初始化失败:', error);
        setState(prevState => ({
          ...prevState,
          isInitialized: true,
          isLoading: false
        }));
      }
    };
    
    initializeApp();
  }, []);

  const setGlobalState = (newState) => {
    setState((prevState) => ({ ...prevState, ...newState }));
  };

  const updateNavigationState = (newNavigationState) => {
    setState((prevState) => ({
      ...prevState,
      navigationState: {
        ...prevState.navigationState,
        ...newNavigationState
      }
    }));
  };

  const openModal = (type, data) => {
    setState((prevState) => ({
      ...prevState,
      modalOpen: true,
      modalType: type,
      modalData: data
    }));
  };

  const closeModal = () => {
    setState((prevState) => ({
      ...prevState,
      modalOpen: false,
      modalType: null,
      modalData: null
    }));
  };

  const setLoading = (isLoading) => {
    setState((prevState) => ({
      ...prevState,
      isLoading
    }));
  };

  return (
    <AppContext.Provider value={{ 
      ...state, 
      setGlobalState,
      updateNavigationState,
      openModal,
      closeModal,
      setLoading,
      globalState: state
    }}>
      {children}
    </AppContext.Provider>
  );
};

export const useAppViewModel = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppViewModel must be used within an AppProvider');
  }
  return context;
};

export const useGlobalState = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useGlobalState must be used within an AppProvider');
  }
  return context;
}
